import { render } from "./dropSmallMenu.vue?vue&type=template&id=acbf1526&scoped=true"
import script from "./dropSmallMenu.vue?vue&type=script&lang=js"
export * from "./dropSmallMenu.vue?vue&type=script&lang=js"

import "./dropSmallMenu.vue?vue&type=style&index=0&id=acbf1526&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-acbf1526"

export default script